import { takeEvery } from "@redux-saga/core/effects";
import { UIActionTypes } from "./../types";
import { updateIsPaginationActiveSaga } from "./changeIsPaginationActive";
import { updatePagesViewModeSaga } from "./changePagesViewMode";

export default function* UISaga() {
    yield takeEvery(UIActionTypes.CHANGE_PAGE_VIEW_MODE_REQUEST, updatePagesViewModeSaga);
    yield takeEvery(UIActionTypes.CHANGE_PAGINATION_ACTIVE_STATUS_REQUEST, updateIsPaginationActiveSaga);
}
